import "./App.css";
import { createTheme, ThemeProvider } from "@mui/material";
import RoutesDefinitions from "./routes/RoutesDefinitions";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./store/store";
import "./resources/scss/main.scss";
import "moment/locale/fr";
import moment from "moment";
import React from "react";
import Cookies from "universal-cookie";
import GlobalMediaPlayer from "./components/videoPodcast/globalPlayer/GlobalMediaPlayer";

function App() {
  const queryParameters = new URLSearchParams(window.location.search);

  const setCookie = (cookieValue) => {
    const cookies = new Cookies();
    cookies.set(cookieValue.name, cookieValue.valeur, {
      path: "/",
      domain: ".inexplore.com",
      expires: new Date(Date.now() + cookieValue.duree),
    });
  };

  React.useEffect(() => {
    const affiliation = queryParameters.get("affiliation");
    const tracking = queryParameters.get("tracking");
    if (affiliation)
      setCookie({
        name: "affiliation",
        valeur: affiliation,
        duree: 2678400000,
      });
    if (tracking)
      setCookie({ name: "tracking", valeur: tracking, duree: 267840000 });
  }, [queryParameters]);

  const theme = createTheme({
    shadows: [
      "none",
      "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
      "0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)",
      "0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)",
      "0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",
      "0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)",
      "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)",
      "0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)",
      "0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)",
      "0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)",
      "0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)",
      "0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)",
      "0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)",
      "0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)",
      "0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)",
      "0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)",
      "0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)",
      "0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)",
      "0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)",
      "0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)",
      "0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)",
      "0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)",
      "0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)",
      "0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)",
      "0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)",
      "5px 0 40px lightgrey;",
      "0px 0px 25px 0px #162A41AA;",
      "0px 0 45px #d3d3d399;",
    ],
    typography: {
      fontFamily: [
        "Branding SemiBold",
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Roboto",
        "Helvetica Neue",
        "Arial",
        "sans-serif",
        "Apple Color Emoji",
        "Segoe UI Emoji",
        "Segoe UI Symbol",
      ].join(","),
      h1: {
        fontFamily: "YesevaOne",
        fontWeight: 400,
        fontSize: "clamp(2rem, 5vw + 1rem, 3rem)", // Adjusted min size to 2rem (~32px)
        lineHeight: 1.2,
        marginTop: "2rem",
        marginBottom: "1rem",
      },
      h2: {
        fontFamily: "YesevaOne",
        fontWeight: 400,
        fontSize: "clamp(1.75rem, 4vw + 1rem, 2.25rem)", // Adjusted min size to 1.75rem (~28px)
        lineHeight: 1.3,
        marginTop: "1.5rem",
        marginBottom: "0.75rem",
      },
      h3: {
        fontFamily: "Branding SemiBold",
        fontWeight: 400,
        fontSize: "clamp(1rem, 3vw + 0.5rem, 1.5625rem)", // Adjusted min size to 1rem (16px)
        lineHeight: 1.4,
        marginTop: "1.25rem",
        marginBottom: "0.5rem",
      },
      h4: {
        fontFamily: "Branding Bold",
        fontWeight: 400,
        fontSize: "clamp(1rem, 2.5vw + 0.5rem, 1.25rem)", // Adjusted min size to 1rem (16px)
        lineHeight: 1.5,
        marginTop: "1rem",
        marginBottom: "0.25rem",
      },
      h5: {
        fontFamily: "Branding SemiBold",
        fontWeight: 400,
        fontSize: "clamp(0.9rem, 2vw + 0.5rem, 1.125rem)", // Adjusted min size to 0.9rem (~14.4px)
        lineHeight: 1.5,
        marginTop: "0.75rem",
        marginBottom: "0.25rem",
      },
      h6: {
        fontFamily: "Branding SemiBold",
        fontWeight: 400,
        fontSize: "clamp(0.8rem, 1.5vw + 0.5rem, 1rem)", // Adjusted min size to 0.8rem (~12.8px)
        lineHeight: 1.5,
        marginTop: "0.5rem",
        marginBottom: "0.25rem",
      },
      body1: {
        fontFamily: "Branding Medium",
        fontSize: "1rem",
        lineHeight: 1.6,
      },
      body2: {
        fontFamily: "Branding Medium",
        fontSize: "1rem",
        lineHeight: 1.6,
      },
      button: {
        fontFamily: "Branding Medium",
      },
    },
    palette: {
      primary: {
        main: "#2271FE",
      },
      secondary: {
        main: "#182B43",
        warning: "#F07892",
      },
      lightgrey: "#C7C4DE",
      lightgreen: "#A5D0C9",
      inexploreGradient: "linear-gradient(90deg, #21639E 0%, #6C3490 100%)",
      linearPro: "linear-gradient(90deg, #992FDD 0%, #1D73FF 100%)",
      odyseeColor: "#EF7D8F",
      yellow: "#F1C555",
      yellowPro: "#F7E144",
      blackPro: "#0D0034",
      blackProLighter: "#120039",
      greenPro: "#0596A1",
      bluePro: "#3971F6",
      purplePro: "#9A45F4",
      videoColors: {
        button: "#060013",
        buttonHover: "rgba(50, 50, 70, 0.7)"
      },
      text: {
        primary: "#182B43",
        secondary: "#182B43",
      },
    },
    shape: {
      borderRadius: 0,
    },
  });

  moment.locale("fr");

  return (
    <div
      className="App"
      style={{
        width: "100%",
        height: "100%",
      }}
    >
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ThemeProvider theme={theme}>
            <RoutesDefinitions />
            <GlobalMediaPlayer />
          </ThemeProvider>
        </PersistGate>
      </Provider>
    </div>
  );
}

export default App;
